import { useState } from "react";
import NewTaskGroupButton from "@common-components/tasks-action-bar/add-task-group-button/new-task-group-button";
import { namespace } from "@common-config/constants";
import { getBlueticksThemeSelector, getCurrentBoard, getSelectedBoardId } from "@common-reducers/BoardsSelectors";
import { boardsSelectors } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { automation } from "@common-reducers/AutomationReducer";
import { MODAL, modalActions } from "@common-reducers/ModalReducer";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdAutoAwesome, MdFileUpload } from "react-icons/md";

import TaskPanelHeaderImportButton from "../filter-button/import-button";
import KanbanSettingsDrawer from "../kanban/kanban-settings-drawer";
import OpenFilterPanelButtonShadcn from "../filter-button/open-filters-panel-button-shadcn";
import classes from "./tasks-panel-header.module.scss";

// Shadcn Components
import SearchTasksShadcn from "@common-views/task-view/search-tasks/search-tasks-shadcn";
import PersonFilterShadcn from "../person-button-filter/person-filter-shadcn";
import ColumnsDropdownShadcn from "./columns-dropdown-shadcn";
import ToolbarButton from "@common-components/toolbar-button";
import MobileToolbarMenu from "./mobile-toolbar-menu";

type Props = {
  isDisplayNewGroupButton?: boolean;
  isDisplaySearchField?: boolean;
  isDisplayPersonButton?: boolean;
  isDisplayColumnsButton?: boolean;
  isDisplayImportButton?: boolean;
  isDisplayExportButton?: boolean;
  isFromCampaign?: boolean;
}

function TasksPanelHeader({
  isDisplayNewGroupButton = true,
  isDisplaySearchField = true,
  isDisplayPersonButton = true,
  isDisplayColumnsButton = true,
  isDisplayImportButton = true,
  isDisplayExportButton = true,
  isFromCampaign = false,
}: Props) {
  const { t } = useTranslation(namespace);
  const _theme = useAppSelector((state) => getBlueticksThemeSelector(state))
  const currentBoard = useAppSelector(getCurrentBoard)
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const direction = useAppSelector((state) => state.UserReducer.direction);
  const currentBoardView = useAppSelector((state) => state.TasksReducer.currentBoardView)
  const selectedBoardId = useAppSelector(getSelectedBoardId);
  const board = useAppSelector((state) =>
    boardsSelectors.selectById(state, selectedBoardId)
  );

  const [anchorElImportMenu, setAnchorElImportMenu] = useState<null | HTMLElement>(null);
  const openImportMenu = Boolean(anchorElImportMenu);

  const dispatch = useAppDispatch();

  function openAutomationsModal() {
    dispatch(
      automation.setIsShown(true)
    );
  }

  function openExportModal() {
    dispatch(modalActions.setComponentToRender(MODAL.EXPORT_TO_EXCEL));
  }

  return (
    <Stack direction="row" sx={{
      display: (currentBoardView.type === 'form' || currentBoardView.type === 'workload' || currentBoardView.type === 'gantt') ? 'none' : 'block',
    }}>
      <div className={classes.headerContainer}>
        <Stack direction="row" spacing={0.7} className={classes.header} alignItems="center">
          {isDisplayNewGroupButton && currentBoardView.type === "board" && <NewTaskGroupButton position="top" />}

          {isDesktop && (
            <div className="flex items-center gap-2">
                {isDisplaySearchField && <SearchTasksShadcn boardType={currentBoard?.type} />}
                
                {isDisplayPersonButton && <PersonFilterShadcn />}
                
                <OpenFilterPanelButtonShadcn />

                {isDisplayColumnsButton && <ColumnsDropdownShadcn />}

                {isDisplayImportButton &&
                  <TaskPanelHeaderImportButton
                    isFromCampaign={isFromCampaign}
                  />
                }



                {/* {isDisplayExportButton &&
                  <>
                    <ToolbarButton
                      startIconSVG={MdFileUpload}
                      onClickAction={openExportModal}
                      buttonText={t('tasksPanelHeader.export')}
                      className={classes.button_col}
                      toolTipTitle={t('tasksPanelHeader.exportDataTooltip')}
                    />
                    {currentBoardView.type === 'gantt' && (<Button
                      onClick={
                        () => dispatch(ganttActions.setSettingsMode(!ganttSettingsMode))
                      }
                      className={classes.button_col}
                      startIcon={<SettingsOutlined style={{ width: 24, height: 24 }} />}
                      value={t('tasksPanelHeader.export')}
                      style={{
                        display: currentBoardView.type === 'gantt' ? 'block' : 'none',
                        position: "absolute",
                        right: 0,
                      }}
                    />)
                    }
                  </>
                } */}

                {isDisplayExportButton && (
                  <ToolbarButton
                    startIconSVG={MdFileUpload}
                    onClickAction={openExportModal}
                    buttonText={t('tasksPanelHeader.export')}
                    className={classes.button_col}
                    toolTipTitle={t('tasksPanelHeader.exportDataTooltip')}
                  />
                )}

                {/* <ToolbarButton
                    startIconSVG={MdFileDownload}
                    onClickAction={openImportModal}
                    buttonText={t('tasksPanelHeader.import')}
                    toolTipTitle={t('tasksPanelHeader.importDataTooltip')}
                    className={classes.button_col}
                  /> */}


                {/* <ToolbarButton
                  startIconSVG={MdFileUpload}
                  onClickAction={openExportModal}
                  buttonText={t('tasksPanelHeader.export')}
                  toolTipTitle={t('tasksPanelHeader.exportToExcel')}
                  className={classes.button_col}
                /> */}

                {/* {currentBoardView.type === 'gantt' && (<Button
                  onClick={
                    () => dispatch(ganttActions.setSettingsMode(!ganttSettingsMode))
                  }
                  className={classes.button_col}
                  startIcon={<SettingsOutlined style={{ width: 24, height: 24 }} />}
                  value={t('tasksPanelHeader.export')}
                  style={{
                    display: currentBoardView.type === 'gantt' ? 'block' : 'none',
                    position: "absolute",
                    right: 0,
                  }}
                />)} */}
                {board?.displayBetaFeatures &&
                  <ToolbarButton
                    onClickAction={openAutomationsModal}
                    className={classes.button_col}
                    startIcon={<MdAutoAwesome style={{ width: 16, height: 16 }} />}
                    buttonText="Automations"
                    toolTipTitle="Create automations"
                  />
                }
            </div>
          )}

          {!isDesktop && (
            <div className="flex items-center gap-2 flex-1 min-w-0">
              {isDisplaySearchField && (
                <div className="flex-1 min-w-0">
                  <SearchTasksShadcn boardType={currentBoard?.type} />
                </div>
              )}

              <MobileToolbarMenu
                isDisplayPersonButton={isDisplayPersonButton}
                isDisplayColumnsButton={isDisplayColumnsButton}
                isDisplayImportButton={isDisplayImportButton}
                isDisplayExportButton={isDisplayExportButton}
                isFromCampaign={isFromCampaign}
                board={board}
              />
            </div>
          )}

          {currentBoardView.type === "kanban" &&
            <KanbanSettingsDrawer kanbanId={currentBoardView.id ?? ''} />
          }

        </Stack >
      </div >
    </Stack >
  );
}

export default TasksPanelHeader;
